import { ErrorHandler, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@teamsp/components/toast';

import { NoNetworkService } from '../services/no-network/no-network.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(
    private translate: TranslateService,
    private noNetworkService: NoNetworkService,
    private toastService: ToastService
  ) {
    super();
  }

  handleError(error: Error) {
    let message =
      this.translate.instant('EttTillfälligtFelUppstod_VäntaEnStundOchFörsökIgen_OmProblemet') ||
      this.translate.instant('EttOhanteratFelUppstod');
    if (!this.noNetworkService.isNetworkAvailable()) {
      message = this.translate.instant('DuÄrOffline');
      this.toastService.warning(message);
    } else {
      this.toastService.error(message);
    }
    super.handleError(error);
  }
}
